import { Col, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
interface InfoProps {
  infoArray: any;
  className?: string;
}
const InfoContent = ({ infoArray }: InfoProps) => {
  const { t } = useTranslation();
  return (
    <>
      <Row className="takaful--content-profile-box1">
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <p>رقم الأسرة</p>
        </Col>
        <Col
          xxl={6}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <span>{infoArray?.family_number}</span>
        </Col>

        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
          <p>حالة الأسرة</p>
        </Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
          <span>{t(`family_state.${infoArray?.family_state}`)}</span>
        </Col>
      </Row>
      <Row className="takaful--content-profile-box1">
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <p>الفرع</p>
        </Col>
        <Col
          xxl={6}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <span>{infoArray?.branch_id}</span>
        </Col>

        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
          <p>المحافظة</p>
        </Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
          <span>{infoArray?.governorate_id}</span>
        </Col>
      </Row>
      <Row className="takaful--content-profile-box1">
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <p>الحي</p>
        </Col>
        <Col
          xxl={6}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <span>{infoArray?.neighborhood_id}</span>
        </Col>

        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
          <p> إسم الشارع و رقم المبنى</p>
        </Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
          <span>{infoArray?.street}</span>
        </Col>
      </Row>
      <Row className="takaful--content-profile-box1">
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <p>الهاتف الأول</p>
          </Col>
        <Col
          xxl={6}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <span>{infoArray?.mobile}</span>
          </Col>

        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
        <p>الهاتف الثاني</p>
        </Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
        <span>{infoArray?.phone}</span>
        </Col>
      </Row>
      <Row className="takaful--content-profile-box1">
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <p>البريد الإلكتروني</p>
          </Col>
        <Col
          xxl={6}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <span>{infoArray?.email}</span>
          </Col>

        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
        <p>الفئة</p>
        </Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
        <span>{infoArray?.beneficiary_category_id}</span>
        </Col>
      </Row>
      <Row className="takaful--content-profile-box1">
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <p>عدد الأفراد</p>
          </Col>
        <Col
          xxl={6}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <span>{infoArray?.family_members_number}</span>
          </Col>

        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
        <p>عدد المستفيدين</p>
        </Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
        <span>{infoArray?.beneficiaries_number}</span>
        </Col>
      </Row>

    </>
  );
};

export default InfoContent;
